<script lang="ts" setup>
defineOptions({ inheritAttrs: false });
</script>

<template>
  <slot />
</template>
